<template>
  <div class="login-container"></div>
</template>

<script>
import {
  getToken,
  setFirebase,
  getReturnUrl,
  removeUrlKey,
} from "@/utils/auth";
import firebase from "firebase/app";
import "firebase/messaging";
export default {
  data() {
    return {
      loading: false,
      connectionFaild: false,
    };
  },
  computed: {
    branches() {
      return this.$store.getters.branches;
    },
  },
  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  },
  created() {
    this.checkToken();

    // window.addEventListener('hashchange', this.afterQRScan)
  },
  methods: {
    checkToken() {
      if (this.$route.query.token != null) {
        this.$store.commit("SET_TOKEN", this.$route.query.token);
        const url = getReturnUrl();
        removeUrlKey();
        this.$store.dispatch("GetUserInfo");
        this.$store.dispatch("GetBranchNames", url);
        // console.log("recive token from server and go to dashboard");
      } else {
        var tok = getToken();
        // console.log("getToken()=> token=" + tok);
        if (!tok) {
          // console.log("token Not Exist go to OpenID");
          this.handleOpenID("");
        } else {
          //  console.log("token exists go to dashboard");
          this.$router.push({ path: "/" });
        }
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("LoginByUsername", this.loginForm)
            .then(() => {
              this.loading = false;
              this.$router.push({ path: "/" });
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleOpenID() {
      var url = process.env.VUE_APP_API_ENDPOINT;
      window.location.href = url;
    },
  },
};
</script>

<style></style>
